var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-button"},[_c('input',{attrs:{"type":"radio","id":_vm.id,"disabled":_vm.disabled},domProps:{"checked":_vm.checked}}),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }